"use client";
import React from "react";
import courseImage from "@/public/images/courseImage.jpg";
import time from "@/public/images/time.svg";
import view from "@/public/images/view.svg";
import heart from "@/public/images/heart.svg";
import reda from "@/public/images/reda.jpg";
import locationGrey from "@/public/images/locationGrey.svg";
import calendar from "@/public/images/calendar.svg";
import faculityExist from "@/public/images/faculityExist.svg";
import blackCap from "@/public/icons/SquareAcademicCap.svg";
import hourse from "@/public/images/hourse.svg";
import program from "@/public/images/program.svg";
import Image from "next/image";

const Index = () => {
  return (
    <div
      style={{ boxShadow: " 0px 4px 54px 0px rgba(0, 0, 0, 0.05)" }}
      className=" w-full  relative rounded-[10px] bg-white p-4 flex flex-col gap-4 "
    >
      <div>
        <Image
          src={courseImage}
          alt="courseImage"
          className=" rounded-[10px] w-full"
        />
      </div>

      <p className=" text-14 w-fit text-darkText font-[500] border border-[#EBEBEB] py-2 px-7 rounded-[10px]">
        اوفلاين
      </p>

      <div className=" flex items-center gap-4">
        <Image
          src={reda}
          alt="euc"
          className=" border border-[#EBEBEB] rounded-[10px]"
        />
        <div className=" grow">
          <div className=" flex items-center gap-2 ">
            <Image src={blackCap} alt="locationGrey" />
            <p className=" text-16 text-descriptionText">الكيمياء</p>
          </div>
          <p className=" text-20 text-descriptionText font-[500]">
            مستر محمد عبد الجواد
          </p>
        </div>
        <p className=" text-[16px] text-nowrap text-primaryColor py-1 px-[15px] rounded-full border border-primaryColor">
          60 جنية
        </p>
      </div>
      <p className=" text-20 text-darkText font-[500]">
        معسكر اختبار البرمجيات Software Testing BootCamp{""}
      </p>
      <div className=" grid grid-cols-3 gap-3">
        <div className=" bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-3">
          <Image src={hourse} alt="calendar" />
          <p className=" text-14 text-darkText ">ساعات الكورس</p>
          <p className=" text-14 text-[#ACB5BB] font-[600]">40 ساعة</p>
        </div>
        <div className=" bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-3">
          <Image src={calendar} alt="calendar" />
          <p className=" text-14 text-darkText ">تاريخ الكورس</p>
          <p className=" text-[14px] text-center text-[#ACB5BB] font-[600]">
            الثلاثاء، ٦ فبراير ٢٠٢٤
          </p>
        </div>
        <div className=" bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-3">
          <Image src={program} alt="calendar" />
          <p className=" text-14 text-darkText ">البروجرم </p>
          <p className=" text-[14px] text-[#ACB5BB] font-[600]">10 بروجرام</p>
        </div>
      </div>
      <div className=" flex items-center gap-3">
        <button className=" text-20 text-white bg-primaryColor h-[58px] grow flex justify-center items-center rounded-[10px]">
          حجز الكورس
        </button>
        <div className=" h-[58px] rounded-[15px] w-[58px] border border-[#EBEBEB]  flex items-center justify-center cursor-pointer">
          <Image src={heart} alt="heart" />
        </div>
      </div>
    </div>
  );
};

export default Index;
